import * as React from "react";
import type { SVGProps } from "react";
const Resort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_5084)">
      <path
        fill="currentColor"
        d="m14.4292 12.6582-2.5042-.9125-3.0083 8.2542H1.3333A1.332 1.332 0 0 0 0 21.3332c0 .7375.5958 1.3333 1.3333 1.3333h21.3334A1.332 1.332 0 0 0 24 21.3332a1.332 1.332 0 0 0-1.3333-1.3333H11.7542l2.6708-7.3417zm5.0458-.0083-.1375.3791 2.8208 1.025c.7542.275 1.5834-.175 1.65-.975.2709-3.2708-.9958-6.4791-3.3666-8.6875.0833.3334.1333.6792.1416 1.0334l.0084.25a18.68 18.68 0 0 1-1.1167 6.975m-.225-7.1875c-.0458-1.4334-.9375-2.7-2.2667-3.225-.0375-.0167-.0791-.0292-.1166-.0459-1.375-.4875-2.9084-.1-3.8792.9917l-.1667.1875C11.35 5.0124 10.2083 6.9249 9.45 8.9999l-.1375.3791 8.7708 3.1917.1375-.3792c.7542-2.075 1.1084-4.2708 1.0375-6.4791zm-14.7833.575c-.4625.6541-.1167 1.5333.6375 1.8083l2.9583 1.075.1375-.3792a18.68 18.68 0 0 1 3.6292-6.0625l.1666-.1875a5.07 5.07 0 0 1 .8542-.7583c-3.3167.1042-6.4458 1.7583-8.3833 4.5z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_5084">
        <path fill="transparent" d="M0 1.333h24v21.3333H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Resort;
